import {imageUrl,isCache}  from "../../src/utils/requset.js"
import {getPlatform,getStockList} from "@/utils/api";

export function getDateMonth (date){
    if (date == null){
        date = new Date(date);
    }
    console.log(date);
    let year = date.getFullYear();
    let month = date.getMonth()+1;
    if (month<10){
        month='0'+month;
    }
    return year+'-'+month
}
export function getFullUrl (data){
    if (data.includes('http://') || data.includes('https://')){
        return data
    }
    if (data){
        return  imageUrl + data
    }
    return null
}
export function isValidEmail(email) {
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return regex.test(email);
}
export function getLocalPlatform(isForce) {
    let platformList =  localStorage.getItem('platformList')
    if( !isForce && isCache && platformList){
        return Promise.resolve(JSON.parse(platformList))
    }else{
        // 返回Promise以便调用者可以正确等待数据加载
        return getPlatform({"platformStatus":true,'PageSize':100000000}).then(res => {
            console.log(res)
            localStorage.setItem('platformList',JSON.stringify(res.Data))
            return res.Data || []
        }).catch(err=>{
            console.log(err)
            localStorage.setItem('platformList',JSON.stringify([]))
            return []
        })
    }
}

export function getLocalStockList(isForce) {
    let stockList =  localStorage.getItem('stockList')
    if( !isForce && isCache && stockList){
        return Promise.resolve(JSON.parse(stockList))
    }else{
        // 返回Promise以便调用者可以正确等待数据加载
        return getStockList({"warehousStatus":1,'PageSize':100000000}).then(res => {
            console.log(res)
            localStorage.setItem('stockList',JSON.stringify(res.Data))
            return res.Data || []
        }).catch(err=>{
            console.log(err)
            localStorage.setItem('stockList',JSON.stringify([]))
            return []
        })
    }
}

export function getNextWeekDay(isFormat=false) {
    // dayOfWeek: 0-6 (0是周日，1是周一，...6是周六)
    const today = new Date();
    const currentDay = today.getDay();
    const tempDay = {
        0:3,
        6:3,
        1:3,
        2:4,
        3:5,
        4:1,
        5:2,
    }
    const dayOfWeek = tempDay[currentDay];
    const daysToAdd = (7 - currentDay + dayOfWeek) % 7 || 7;
    const nextWeekDay = new Date(today);
    nextWeekDay.setDate(today.getDate() + daysToAdd);
    const year = nextWeekDay.getFullYear(); // 年
    let month =  nextWeekDay.getMonth() + 1; // 月份从0开始需加1
    month = isFormat ? ( month<10 ? "0"+month:month ) : month;
    let day = nextWeekDay.getDate();
    day = isFormat ? ( day<10 ? "0"+day:day ) : day;
    return isFormat ? `${year}-${month}-${day}`  : `${month}/${day}` ;
}
export function isMobile() {
    const ua = navigator.userAgent;
    const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
    const hasTouch = navigator.maxTouchPoints > 1;
    const isSmallScreen = window.innerWidth <= 960;
    // 排除桌面模式干扰
    const isDesktopMode = /Macintosh/i.test(ua) && !/Mobile/i.test(ua);

    return (isMobileUA || hasTouch) && isSmallScreen && !isDesktopMode;
}


